// extracted by mini-css-extract-plugin
module.exports = {"main":"fonts-extended_main__AJpmI"};